import {faBell} from "@fortawesome/pro-solid-svg-icons/faBell";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {AvatarSize, Button, ButtonSize} from "@twigsby/frontend-framework";
import React from "react";
import {useUKPBAuth} from "../Providers/AuthProvider";
import {useSite} from "../Providers/SiteInterfaceProvider";
import {Logo} from "./Logo";
import UserMenu from "./UserMenu";
import { UserAccountAlert } from './User/UserAccountAlert';

type HeaderType = {
    showLogo?: boolean;
    isBranded?: boolean;
}

const Header = (props: HeaderType) => {
    const { token} = useUKPBAuth();

    return (
        <div className={`generic-header ${props.isBranded ? 'branded' : ''}`}>
            <UserAccountAlert />
        </div>
    )
}

export { Header }
